/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { BaseBlockContent } from "src/components/Block/styles";

export const EmbeddedPlateBlockContent = styled(BaseBlockContent)`
  overflow-y: hidden;
`;

export const PageBlockMaxWidth = styled.div`
  max-width: 240px;
  padding: 24px;
`;

export const PageBlockWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
